import { CurrencyPipe, DecimalPipe } from '@angular/common';
import {
  Component,
  inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Button } from 'primeng/button';
import { MultiSelectModule } from 'primeng/multiselect';
import { Subscription } from 'rxjs';
import { Equipment } from '../../../../models/equipment.model';
import { QuoteRevisionItem } from '../../../../models/quote-revision-item.model';
import { QuoteItemEquipment } from '../../../../models/quote-item-equipment.model';
import { EquipmentService } from '../../../equipment.service';
import { QuoteRevisionItemService } from '../../../services/quote-revision-item.service';

@Component({
  selector: 'app-quote-revision-item-capex-information',
  imports: [Button, CurrencyPipe, DecimalPipe, FormsModule, MultiSelectModule],
  templateUrl: './capex-information.component.html',
})
export class QuoteRevisionItemCapexInformationComponent
  implements OnInit, OnChanges, OnDestroy
{
  @Input({ required: true }) item!: QuoteRevisionItem;
  @Input({ required: true }) currencyCode!: string;
  @Input() readOnly = false;

  private readonly revisionItemService = inject(QuoteRevisionItemService);
  private readonly equipmentService = inject(EquipmentService);
  private subscription?: Subscription;
  equipmentOptions: Equipment[] = [];
  selectedEquipmentIds: number[] = [];
  editMode = false;
  saving = false;

  get selectedEquipmentLinks(): QuoteItemEquipment[] {
    return this.item.equipment_links;
  }

  ngOnInit(): void {
    this.subscription = this.equipmentService.activeEquipment$.subscribe(
      (equipment) => (this.equipmentOptions = equipment),
    );
    void this.equipmentService.loadEquipment();
    this.resetSelection();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['item']) this.resetSelection();
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  resetSelection(): void {
    this.selectedEquipmentIds =
      this.item?.equipment_links.map((link) => link.equipment.id) ?? [];
  }

  startEdit(): void {
    this.resetSelection();
    this.editMode = true;
  }

  cancelEdit(): void {
    this.resetSelection();
    this.editMode = false;
  }

  async save(): Promise<void> {
    if (this.readOnly) return;
    this.saving = true;
    try {
      await this.revisionItemService.updateItem(this.item.persistent_id, {
        equipment_links: this.selectedEquipmentIds.map((equipment_id) => ({
          equipment_id,
        })),
      });
    } finally {
      this.saving = false;
    }
  }

  edit(): void {
    this.startEdit();
  }
}
